import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('iling-theme');
    return saved || 'dark';
  });

  const [halloweenMode, setHalloweenMode] = useState(() => {
    return localStorage.getItem('iling-halloween') === 'true';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');
    root.classList.add(theme);
    localStorage.setItem('iling-theme', theme);
  }, [theme]);

  useEffect(() => {
    const root = window.document.documentElement;
    if (halloweenMode) {
      root.classList.add('halloween');
    } else {
      root.classList.remove('halloween');
    }
    localStorage.setItem('iling-halloween', String(halloweenMode));
  }, [halloweenMode]);

  const toggleTheme = () => {
    setTheme(prev => {
      const newTheme = prev === 'light' ? 'dark' : 'light';
      return newTheme;
    });
  };

  const toggleHalloween = () => setHalloweenMode(prev => !prev);

  const value = {
    theme,
    setTheme,
    toggleTheme,
    isDark: theme === 'dark',
    halloweenMode,
    toggleHalloween,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
